export default __webpack_public_path__ + "ed3a30adb6e04cbd66ac1f5ba3fe08aa.png";